import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  employeeSurveySubmissionId: string;
};

const request = ({ employeeSurveySubmissionId }: RequestDataType) => {
  return new ApiClient()
    .post<ResponseMessageType>(
      `/api/members/employee_survey_submissions/${employeeSurveySubmissionId}/bookmarks`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersEmployeeSurveySubmissionsBookmarksCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
